import {Box} from "@mui/material";
import React from "react";
import CCOLinkable from "../../fundamentals/CCOLinkable";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import CCOAccordion from "../../fundamentals/CCOAccordion";
import {generateDownloadUrl} from "../../../utility/navigationUtil";
import useWindowSize from "../../../utility/useWindowSize";

interface Props {
    indexKey: number
    teaserTitle: string
    items: Array<any>
    padding?: number | string
}

function FooterMenu(props: Props) {
    const {lowerThanWindowLarge} = useWindowSize()

    const link = (item: any, index: number) => {
        const isCMDownload = item.type === 'CMDownload'
        return <CCOLinkable dataCypress={props.teaserTitle + index}
                            type={"footer"}
                            openInTab={isCMDownload}
                            key={index}
                            target={isCMDownload ? generateDownloadUrl(item.id ?? '', item.teaserTitle ?? '') : item}
                            name={item.teaserTitle}/>
    }

    return <React.Fragment key={props.indexKey}>
        <Box data-cypress={'footerMenu'} sx={{display: 'grid', alignSelf: 'start', p: props.padding, width: '100%'}}>
            {lowerThanWindowLarge ?
                <CCOAccordion propertyName='properties.teaserTitle' title={props.teaserTitle} sx={{
                    backgroundColor: 'transparent', borderTop: 'none'
                }}><>
                    {props.items.map((item, index) => (
                        link(item, index)
                    ))
                    }</>
                </CCOAccordion>
                : <>
                    <CCOHeadline headline={props.teaserTitle} type={"h4"} justify={"left"}/>
                    {
                        props.items.map((item, index) => (
                            link(item, index)
                        ))
                    }
                </>
            }
        </Box>
    </React.Fragment>
}


export default FooterMenu